import { Support } from '@iguanads/icons/two-colors'
import { Badge, Button, cn } from '@iguanads/react'
import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { useFrontChat } from '@/hooks/use-front-chat'
import useAuth from '@/hooks/useAuth'

function HelpFab({ className, ...props }: ComponentProps<typeof Button>) {
  const { t } = useTranslation()
  const { user } = useAuth()
  const { openChat, unreadCount } = useFrontChat()
  const { pathname } = useLocation()

  const isLiveOrders = pathname === '/'
  const isMenuMaker = pathname.startsWith('/menu-maker')

  if (!user) return null

  return (
    <div
      className={cn(
        'fixed right-7 z-40',
        'bottom-22 md:bottom-6',
        {
          'bottom-38 min-[940px]:bottom-6! md:bottom-20': isLiveOrders,
          'bottom-50 min-[940px]:bottom-22! md:bottom-36': isMenuMaker,
        },
        className
      )}
    >
      {unreadCount > 0 && (
        <Badge
          status={null}
          size="sm"
          className="absolute bottom-full right-0 mb-2 border-transparent bg-pink-base px-3 text-sm text-grayscale-white shadow-sm"
        >
          {t('common.newMessageCount', { count: unreadCount })}
        </Badge>
      )}

      <Button
        variant="tertiary"
        onClick={() => openChat()}
        className="rounded-full px-4 shadow-sm"
        {...props}
      >
        {t('common.help')} <Support className="ml-1 size-5" />
      </Button>
    </div>
  )
}

export { HelpFab }
